"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/chat/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } } function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }

var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');


var _react3 = require('@sentry/react'); var Sentry = _interopRequireWildcard(_react3);
var _ServiceScreen = require('web/screens/ServiceScreen'); var _ServiceScreen2 = _interopRequireDefault(_ServiceScreen);



var _subscriptionRedirect = require('web/services/subscriptionRedirect');
var _onboardingAnalytics = require('web/services/onboardingAnalytics');

var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _ConfirmEmailScreen = require('web/screens/ConfirmEmailScreen'); var _ConfirmEmailScreen2 = _interopRequireDefault(_ConfirmEmailScreen);
var _UnsubscribeEmailNotifsScreen = require('web/screens/UnsubscribeEmailNotifsScreen'); var _UnsubscribeEmailNotifsScreen2 = _interopRequireDefault(_UnsubscribeEmailNotifsScreen);
var _CodeScreen = require('web/screens/CodeScreen'); var _CodeScreen2 = _interopRequireDefault(_CodeScreen);

var _Notifications = require('web/components/Notifications'); var _Notifications2 = _interopRequireDefault(_Notifications);
var _Video = require('web/screens/Video'); var _Video2 = _interopRequireDefault(_Video);

var _Login = require('web/screens/Login'); var _Login2 = _interopRequireDefault(_Login);
var _FirstTimeInteractables = require('web/screens/FirstTimeInteractables'); var _FirstTimeInteractables2 = _interopRequireDefault(_FirstTimeInteractables);

var _Setup = require('web/screens/Signup/Setup'); var _Setup2 = _interopRequireDefault(_Setup);
var _OnboardingPayment = require('web/screens/OnboardingPayment'); var _OnboardingPayment2 = _interopRequireDefault(_OnboardingPayment);
var _OnboardingDemo = require('web/screens/OnboardingDemo'); var _OnboardingDemo2 = _interopRequireDefault(_OnboardingDemo);
var _OnboardingSteps = require('web/screens/OnboardingSteps'); var _OnboardingSteps2 = _interopRequireDefault(_OnboardingSteps);

var _Settings = require('web/screens/Settings'); var _Settings2 = _interopRequireDefault(_Settings);
var _AlertsScreen = require('web/screens/AlertsScreen'); var _AlertsScreen2 = _interopRequireDefault(_AlertsScreen);
var _BannerAlertScreen = require('web/screens/BannerAlertScreen'); var _BannerAlertScreen2 = _interopRequireDefault(_BannerAlertScreen);
var _ToastsScreen = require('web/screens/ToastsScreen'); var _ToastsScreen2 = _interopRequireDefault(_ToastsScreen);
var _Super = require('web/screens/Super'); var _Super2 = _interopRequireDefault(_Super);

var _EnterEmail = require('web/screens/Signup/EnterEmail'); var _EnterEmail2 = _interopRequireDefault(_EnterEmail);
var _Inbox = require('web/screens/Inbox'); var _Inbox2 = _interopRequireDefault(_Inbox);
var _Search = require('web/screens/Search'); var _Search2 = _interopRequireDefault(_Search);
var _searchSession = require('web/screens/Search/Refined/searchSession');
var _store = require('web/store');
var _Broadcast = require('web/screens/Broadcast'); var _Broadcast2 = _interopRequireDefault(_Broadcast);
var _RecipientsAddNotices = require('web/screens/Broadcast/RecipientsAddNotices'); var _RecipientsAddNotices2 = _interopRequireDefault(_RecipientsAddNotices);
var _Directory = require('web/screens/Directory'); var _Directory2 = _interopRequireDefault(_Directory);
var _Forms = require('web/screens/Forms'); var _Forms2 = _interopRequireDefault(_Forms);
var _ScanPage = require('web/screens/Forms/Scan/ScanPage'); var _ScanPage2 = _interopRequireDefault(_ScanPage);
var _Sidebar = require('web/components/Sidebar'); var _Sidebar2 = _interopRequireDefault(_Sidebar);
var _FeedbackModal = require('web/components/FeedbackModal'); var _FeedbackModal2 = _interopRequireDefault(_FeedbackModal);

var _VideoMeeting = require('web/screens/VideoMeeting'); var _VideoMeeting2 = _interopRequireDefault(_VideoMeeting);
var _Modals = require('web/components/VideoCall/Modals');
var _SuccessModal = require('web/components/Upgrade/UpgradeModal/SuccessModal'); var _SuccessModal2 = _interopRequireDefault(_SuccessModal);
var _PageNotFoundScreen = require('web/screens/PageNotFoundScreen'); var _PageNotFoundScreen2 = _interopRequireDefault(_PageNotFoundScreen);
var _ErrorModal = require('web/screens/ErrorModal'); var _ErrorModal2 = _interopRequireDefault(_ErrorModal);

var _routes = require('./routes'); var _routes2 = _interopRequireDefault(_routes);
var _noticeBar = require('web/services/context/noticeBar');

var _hooks = require('web/services/hooks');
var _app = require('shared/selectors/app');
var _user = require('shared/selectors/user');
var _useLeaveWarningWhileSending = require('web/hooks/useLeaveWarningWhileSending'); var _useLeaveWarningWhileSending2 = _interopRequireDefault(_useLeaveWarningWhileSending);

// Looser than both the context's ShowNoticeBar and VideoMeeting's (type is
// optional and defaults to 'success'), so one function satisfies both.







const getUserAgentSpecificStyle = () => {
  const userAgent = window.navigator.userAgent
  if ((userAgent.match(/iPhone/i) || userAgent.match(/Android/i) || userAgent.match(/iPad/i)) && window.innerWidth < 561) {
    return {
      height: window.innerHeight,
      width: window.innerWidth,
    }
  } else {
    return {}
  }
}

const renderInbox = () => _react2.default.createElement(_Inbox2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 86}} )
const renderSettings = () => _react2.default.createElement(_Settings2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 87}} )
const renderRootRedirect = () => _react2.default.createElement(_reactrouterdom.Redirect, { to: _routes2.default.INBOX.ROOT, __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}} )






const Application = ({ showNoticeBar, amISuperuser }) => {
  // Was the constructor: read the post-checkout redirect once, before the first render.
  const [subscriptionSuccess] = _react.useState.call(void 0, () => {
    const qs = _subscriptionRedirect.parseSubscriptionSuccessURL.call(void 0, )

    if (_optionalChain([qs, 'optionalAccess', _ => _.planTypes])) {
      _onboardingAnalytics.captureSubscriptionStarted.call(void 0, {
        organization_id: qs.orgKey,
        plan_type: qs.planTypes.join(','),
        action_type: qs.actionType,
      })
    }

    return qs
  })

  const [searchModalOpen, setSearchModalOpen] = _react.useState.call(void 0, false)
  const [isFeedbackOpen, setIsFeedbackOpen] = _react.useState.call(void 0, false)
  const openFeedback = _react.useCallback.call(void 0, () => setIsFeedbackOpen(true), [])
  const closeFeedback = _react.useCallback.call(void 0, () => setIsFeedbackOpen(false), [])
  const [isJoinCallModalOpen, setIsJoinCallModalOpen] = _react.useState.call(void 0, false)
  const [isDesktopNewRoomModalOpen, setIsDesktopNewRoomModalOpen] = _react.useState.call(void 0, false)
  const [isMobileNewRoomModalOpen, setIsMobileNewRoomModalOpen] = _react.useState.call(void 0, false)
  const [isSubscriptionSuccessModalOpen, setIsSubscriptionSuccessModalOpen] =
    _react.useState.call(void 0, !!_optionalChain([subscriptionSuccess, 'optionalAccess', _2 => _2.planTypes]))

  const closeSubscriptionSuccessModal = _react.useCallback.call(void 0, () => {
    setIsSubscriptionSuccessModalOpen(false)
    _subscriptionRedirect.clearQS.call(void 0, )
  }, [])

  // "Back to results" reopens the search window on the last search.
  const [searchRestore, setSearchRestore] = _react.useState.call(void 0, false)
  const openSearchModal = _react.useCallback.call(void 0, () => {
    setSearchRestore(false)
    setSearchModalOpen(true)
  }, [])
  const closeSearchModal = _react.useCallback.call(void 0, () => setSearchModalOpen(false), [])
  _react.useLayoutEffect.call(void 0, () => _searchSession.searchSession.onOpenRequest(restore => {
    setSearchRestore(restore)
    setSearchModalOpen(true)
  }), [])

  const openJoinCallModal = _react.useCallback.call(void 0, () => setIsJoinCallModalOpen(true), [])
  const closeJoinCallModal = _react.useCallback.call(void 0, () => setIsJoinCallModalOpen(false), [])
  const openMobileNewRoomModal = _react.useCallback.call(void 0, () => setIsMobileNewRoomModalOpen(true), [])
  const openDesktopNewRoomModal = _react.useCallback.call(void 0, () => setIsDesktopNewRoomModalOpen(true), [])
  const closeNewRoomModal = _react.useCallback.call(void 0, () => {
    setIsMobileNewRoomModalOpen(false)
    setIsDesktopNewRoomModalOpen(false)
  }, [])

  // Layout effects keep componentDidMount/componentWillUnmount timing.
  _react.useLayoutEffect.call(void 0, () => {
    const itunesMeta = document.createElement('meta')
    itunesMeta.setAttribute('name', 'apple-itunes-app')
    itunesMeta.setAttribute('content', 'app-id=1294498284')
    document.head.appendChild(itunesMeta)
  }, [])

  _react.useLayoutEffect.call(void 0, () => {
    const handleGlobalShortcuts = (event) => {
      // ctrl+f for search.  TODO:  remove flighting check when fully shipped
      if (event.keyCode === 70 && event.metaKey && event.shiftKey) {
        event.preventDefault()
        event.stopPropagation()
        openSearchModal()
      }
    }

    document.addEventListener("keydown", handleGlobalShortcuts, false)
    return () => document.removeEventListener("keydown", handleGlobalShortcuts, false)
  }, [openSearchModal])

  const userAgentStyles = getUserAgentSpecificStyle()

  return (
    _react2.default.createElement('div', { className: "app", style: userAgentStyles, __self: this, __source: {fileName: _jsxFileName, lineNumber: 172}}
      , _react2.default.createElement('div', { className: "app-top", __self: this, __source: {fileName: _jsxFileName, lineNumber: 173}}
        , _react2.default.createElement(_BannerAlertScreen2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 174}} )
      )
      , _react2.default.createElement('div', { className: "app-main", __self: this, __source: {fileName: _jsxFileName, lineNumber: 176}}
        , _react2.default.createElement(_ServiceScreen2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 177}} )
        , _react2.default.createElement(_Sidebar2.default, { onSearch: openSearchModal, onFeedback: openFeedback, __self: this, __source: {fileName: _jsxFileName, lineNumber: 178}} )
        , _react2.default.createElement('div', { className: "app--screen", __self: this, __source: {fileName: _jsxFileName, lineNumber: 179}}
          /* We make the search "live" inside the same frame as most screens for saner object
            * modal and to allow for consistent mobile rendering (where we don't have "fixed"
            * positioning)
            */
          , _react2.default.createElement(_Search2.default, { isOpen: searchModalOpen, restore: searchRestore, onClose: closeSearchModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 184}} )
          ,  isFeedbackOpen && _react2.default.createElement(_FeedbackModal2.default, { onClose: closeFeedback, __self: this, __source: {fileName: _jsxFileName, lineNumber: 185}} ) 
          , _react2.default.createElement(_ToastsScreen2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 186}} )
          , _react2.default.createElement(_FirstTimeInteractables2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 187}} )
          ,  subscriptionSuccess && (
            _react2.default.createElement(_SuccessModal2.default, {
              isOpen: isSubscriptionSuccessModalOpen,
              onClose: closeSubscriptionSuccessModal,
              planTypes: subscriptionSuccess.planTypes,
              actionType: subscriptionSuccess.actionType,
              orgKey: subscriptionSuccess.orgKey,
              source: subscriptionSuccess.source, __self: this, __source: {fileName: _jsxFileName, lineNumber: 189}}
            )
          )
          , _react2.default.createElement(_reactrouterdom.Switch, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 198}}

            /* inbox screens */
            , _react2.default.createElement(_reactrouterdom.Route, { path: _routes2.default.INBOX.NEW, render: renderInbox, __self: this, __source: {fileName: _jsxFileName, lineNumber: 201}} )
            , _react2.default.createElement(_reactrouterdom.Route, { path: _routes2.default.INBOX.CHAT, render: renderInbox, __self: this, __source: {fileName: _jsxFileName, lineNumber: 202}} )

            , _react2.default.createElement(_reactrouterdom.Route, { path: _routes2.default.BROADCAST.ROOT, component: _Broadcast2.default, __self: this, __source: {fileName: _jsxFileName, lineNumber: 204}} )
            , _react2.default.createElement(_reactrouterdom.Route, { path: _routes2.default.DIRECTORY.ENTITY, component: _Directory2.default, __self: this, __source: {fileName: _jsxFileName, lineNumber: 205}} )
            , _react2.default.createElement(_reactrouterdom.Route, { path: _routes2.default.SETTINGS.ROOT, render: renderSettings, __self: this, __source: {fileName: _jsxFileName, lineNumber: 206}} )
            , _react2.default.createElement(_reactrouterdom.Route, { path: _routes2.default.FORMS.ROOT, component: _Forms2.default, __self: this, __source: {fileName: _jsxFileName, lineNumber: 207}} )

            ,  amISuperuser
              ? _react2.default.createElement(_reactrouterdom.Route, { path: _routes2.default.SUPER, component: _Super2.default, __self: this, __source: {fileName: _jsxFileName, lineNumber: 210}} )
              : null
            
            , _react2.default.createElement(_reactrouterdom.Route, { exact: true,
              path: _routes2.default.ROOT,
              render: renderRootRedirect, __self: this, __source: {fileName: _jsxFileName, lineNumber: 213}}
            )
            , _react2.default.createElement(_reactrouterdom.Route, { component: _PageNotFoundScreen2.default, __self: this, __source: {fileName: _jsxFileName, lineNumber: 217}} )
          )
          , _react2.default.createElement(_VideoMeeting2.default, {
            isLoggedIn: true,
            showNoticeBar: showNoticeBar,
            openJoinCallModal: openJoinCallModal,
            closeJoinCallModal: closeJoinCallModal,
            isJoinCallModalOpen: isJoinCallModalOpen,
            openDesktopNewRoomModal: openDesktopNewRoomModal,
            openMobileNewRoomModal: openMobileNewRoomModal,
            closeNewRoomModal: closeNewRoomModal,
            isMobileNewRoomModalOpen: isMobileNewRoomModalOpen,
            isDesktopNewRoomModalOpen: isDesktopNewRoomModalOpen, __self: this, __source: {fileName: _jsxFileName, lineNumber: 219}}
          )
        )
      )
    )
  )
}





const AuthenticatedWebsite = ({ showNoticeBar }) => {
  const authed = _hooks.useAppSelector.call(void 0, _app.selectIsAuthed)
  const clientOpen = _hooks.useAppSelector.call(void 0, _app.selectIsClientOpen)
  const amISuperuser = _hooks.useAppSelector.call(void 0, _user.selectAmISuperUser)

  const [csrfCheckComplete, setCsrfCheckComplete] = _react.useState.call(void 0, false)
  // Only read by onLoginSuccess, so a ref keeps that callback stable like the
  // class method it replaces; every write coincides with a render already.
  const postLoginRoute = _react.useRef(_routes2.default.ROOT)

  // Was componentDidMount (layout timing, before the root's listeners are required).
  _react.useLayoutEffect.call(void 0, () => {
    _client2.default.csrf()
      .then(_actions2.default.loginSuccess)
      .catch(() => {
        const pathname = _optionalChain([_store.history, 'access', _3 => _3.location, 'optionalAccess', _4 => _4.pathname]) || ''
        if (pathname.includes(_routes2.default.LOGIN.ROOT)) return
        postLoginRoute.current = _store.history.location
      })
      .finally(() => setCsrfCheckComplete(true))
  }, [])

  const renderVideoMeeting = _react.useCallback.call(void 0, (props) => (
    _react2.default.createElement(_VideoMeeting2.default, { ...props, showNoticeBar: showNoticeBar, __self: this, __source: {fileName: _jsxFileName, lineNumber: 264}} )
  ), [showNoticeBar])

  const onLoginSuccess = _react.useCallback.call(void 0, () => {
    _store.history.push(postLoginRoute.current)
    postLoginRoute.current = _routes2.default.ROOT
  }, [])

  // Login ignores the route props; they are spread through as before.
  const renderLogin = _react.useCallback.call(void 0, (props) => (
    _react2.default.createElement(_Login2.default, {
      ...props,
      onLoginSuccess: onLoginSuccess, __self: this, __source: {fileName: _jsxFileName, lineNumber: 274}}
    )
  ), [onLoginSuccess])

  /* CSRF check still in flight: hold a branded splash instead of a null
   * render — null painted the body white for seconds between the purple
   * signup screens and the onboarding continuation (or the inbox). The logo
   * + spinner reads as an intentional loading moment rather than a blank
   * purple screen (e.g. on the hard-navigation return from Stripe). */
  if (!csrfCheckComplete) {
    return (
      _react2.default.createElement('div', { className: "app-boot-splash", __self: this, __source: {fileName: _jsxFileName, lineNumber: 287}}
        , _react2.default.createElement('div', { className: "app-boot-splash--inner", __self: this, __source: {fileName: _jsxFileName, lineNumber: 288}}
          , _react2.default.createElement('img', { className: "app-boot-splash--logo", src: "/assets/images/bloomtext-logo.svg", alt: "BloomText", __self: this, __source: {fileName: _jsxFileName, lineNumber: 289}} )
          , _react2.default.createElement('div', { className: "app-boot-splash--pulse", __self: this, __source: {fileName: _jsxFileName, lineNumber: 290}}
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 291}} )
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 292}} )
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 293}} )
          )
        )
      )
    )
  }

  /* The onboarding payment screen must survive a socket drop (Skip needs no
   * socket; pricing + Start self-gate on connection). Keep it mounted whenever
   * the user is authenticated, regardless of clientOpen — otherwise a
   * mid-onboarding disconnect would bounce them to /login and kill the offer. */
  /* The free-path signing continuation shares the payment route's auth/socket
   * posture: it must survive a socket drop and never bounce a mid-onboarding
   * user to /login. An array
   * (not a Fragment) so react-router's Switch still sees each Route directly. */
  const continuationRoutes = authed
    ? [
      _react2.default.createElement(_reactrouterdom.Route, { key: "onboarding-payment", path: _routes2.default.ONBOARDING_PAYMENT, component: _OnboardingPayment2.default, __self: this, __source: {fileName: _jsxFileName, lineNumber: 310}} ),
      _react2.default.createElement(_reactrouterdom.Route, { key: "onboarding-demo", path: _routes2.default.ONBOARDING_DEMO, component: _OnboardingDemo2.default, __self: this, __source: {fileName: _jsxFileName, lineNumber: 311}} ),
      _react2.default.createElement(_reactrouterdom.Route, { key: "onboarding-steps", path: _routes2.default.ONBOARDING_STEPS, component: _OnboardingSteps2.default, __self: this, __source: {fileName: _jsxFileName, lineNumber: 312}} ),
      ]
    : null

  /* if usrrs are not authenticated (or the socket dropped), send 'em to the
   * login screen — but let the payment route render first when authenticated */
  if (!authed || !clientOpen) {
    return (
      _react2.default.createElement(_reactrouterdom.Switch, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 320}}
        , continuationRoutes
        , _react2.default.createElement(_reactrouterdom.Route, { exact: true, path: _routes2.default.VIDEO.V2, render: renderVideoMeeting, __self: this, __source: {fileName: _jsxFileName, lineNumber: 322}} )
        , _react2.default.createElement(_reactrouterdom.Route, { path: _routes2.default.LOGIN.EMAIL_LOGIN, render: renderLogin, __self: this, __source: {fileName: _jsxFileName, lineNumber: 323}} )
        , _react2.default.createElement(_reactrouterdom.Route, { path: _routes2.default.LOGIN.ROOT, render: renderLogin, __self: this, __source: {fileName: _jsxFileName, lineNumber: 324}} )
        , _react2.default.createElement(_reactrouterdom.Redirect, { to: _routes2.default.LOGIN.ROOT, __self: this, __source: {fileName: _jsxFileName, lineNumber: 325}} )
      )
    )
  }

  /* finally, render application appropriate components */
  return (
    _react2.default.createElement(_reactrouterdom.Switch, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 332}}
      , _react2.default.createElement(_reactrouterdom.Route, { path: _routes2.default.LOGIN.ROOT, render: renderLogin, __self: this, __source: {fileName: _jsxFileName, lineNumber: 333}} )
      , _react2.default.createElement(_reactrouterdom.Route, { exact: true, path: "/chats", render: renderRootRedirect, __self: this, __source: {fileName: _jsxFileName, lineNumber: 334}} )
      /* Forms' phone scan page fills the phone's screen, with no sidebar. */
      , _react2.default.createElement(_reactrouterdom.Route, { exact: true, path: _routes2.default.FORMS.SCAN, component: _ScanPage2.default, __self: this, __source: {fileName: _jsxFileName, lineNumber: 336}} )
      /* Rendered as a sibling before Application so FirstTimeInteractablesScreen
        * never mounts over the onboarding payment offer (queued first-login
        * popups stay queued for the inbox; nothing is dismissed or dequeued). */
      , continuationRoutes
      , _react2.default.createElement(Application, { showNoticeBar: showNoticeBar, amISuperuser: amISuperuser, __self: this, __source: {fileName: _jsxFileName, lineNumber: 341}} )
    )
  )
}







const Chat = () => {
  // Ask before the page unloads while a send's files are still uploading.
  _useLeaveWarningWhileSending2.default.call(void 0, )
  const [noticeBar, setNoticeBar] = _react.useState({
    isOpen: false,
    type: 'success',
    text: '',
  })

  const showNoticeBar = _react.useCallback(({ type = 'success', text }) => setNoticeBar({
    text, type, isOpen: true,
  }), [])

  const hideNoticeBar = _react.useCallback.call(void 0, () => setNoticeBar(prev => ({
    ...prev, isOpen: false,
  })), [])

  // Was componentDidMount: the websocket and web listeners register bus handlers
  // when first required, so they stay mount-time and in this order.
  _react.useLayoutEffect.call(void 0, () => {
    require('shared/listeners/websocket')
    require('web/listeners')
  }, [])

  const noticeBarContext = _react.useMemo(() => ({
    showNoticeBar,
    showSuccessBar: text => showNoticeBar({ type: 'success', text }),
    showWarningBar: text => showNoticeBar({ type: 'warning', text }),
  }), [showNoticeBar])

  return (
    _react2.default.createElement(_react.Fragment, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 383}}
      , _react2.default.createElement(_Notifications2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 384}} )
      , _react2.default.createElement(_AlertsScreen2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 385}} )
      , _react2.default.createElement(_Modals.NoticeBar, {
        isOpen: noticeBar.isOpen,
        text: noticeBar.text,
        type: noticeBar.type,
        onClose: hideNoticeBar, __self: this, __source: {fileName: _jsxFileName, lineNumber: 386}}
      )
      , _react2.default.createElement(_noticeBar.NoticeBarContext.Provider, { value: noticeBarContext, __self: this, __source: {fileName: _jsxFileName, lineNumber: 392}}
        /* P2': a background CSV Add's end, for its starter, on any page. */
        , _react2.default.createElement(_RecipientsAddNotices2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 394}} )
        , _react2.default.createElement(_reactrouterdom.Router, { history: _store.history, __self: this, __source: {fileName: _jsxFileName, lineNumber: 395}}
          , _react2.default.createElement(_reactrouterdom.Switch, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 396}}
            , _react2.default.createElement(_reactrouterdom.Route, { exact: true, path: _routes2.default.VIDEO.V1, component: _Video2.default, __self: this, __source: {fileName: _jsxFileName, lineNumber: 397}} )
            , _react2.default.createElement(_reactrouterdom.Route, { exact: true, path: _routes2.default.CONFIRM_EMAIL, component: _ConfirmEmailScreen2.default, __self: this, __source: {fileName: _jsxFileName, lineNumber: 398}} )
            , _react2.default.createElement(_reactrouterdom.Route, { exact: true, path: _routes2.default.UNSUBSCRIBE.EMAIL, component: _UnsubscribeEmailNotifsScreen2.default, __self: this, __source: {fileName: _jsxFileName, lineNumber: 399}} )
            , _react2.default.createElement(_reactrouterdom.Route, { exact: true, path: _routes2.default.CODE, component: _CodeScreen2.default, __self: this, __source: {fileName: _jsxFileName, lineNumber: 400}} )
            , _react2.default.createElement(_reactrouterdom.Route, { exact: true, path: _routes2.default.WELCOME, component: _EnterEmail2.default, __self: this, __source: {fileName: _jsxFileName, lineNumber: 401}} )
            , _react2.default.createElement(_reactrouterdom.Route, { exact: true, path: _routes2.default.CREATE_ACCOUNT, component: _Setup2.default, __self: this, __source: {fileName: _jsxFileName, lineNumber: 402}} )
            , _react2.default.createElement(AuthenticatedWebsite, { showNoticeBar: showNoticeBar, __self: this, __source: {fileName: _jsxFileName, lineNumber: 403}} )
          )
        )
      )
    )
  )
}

exports. default = Sentry.withErrorBoundary(Chat, { fallback: _react2.default.createElement(_ErrorModal2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 411}} ) })
